const DEFAULT_MAX_SERIALS_PER_LINE = 4;
const DEFAULT_MAX_TEXT_LINE_LENGTH = 100;

export function normalizeDeliveryNoteSerialEntry(serialEntry) {
  if (typeof serialEntry === 'string') {
    const serialNumber = serialEntry.trim();
    return serialNumber ? { serialNumber, variantString: null } : null;
  }

  if (!serialEntry || typeof serialEntry !== 'object') return null;

  const serialNumber = String(serialEntry.serialNumber ?? serialEntry.serialnumber ?? '').trim();
  if (!serialNumber) return null;

  const variantString = String(serialEntry.variantString ?? serialEntry.variantstring ?? '').trim() || null;

  return {
    serialNumber,
    variantString
  };
}

function getSerialLinePrefix(variantString, lineIndexWithinVariant) {
  if (!variantString) return 'Serial numbers: ';
  return lineIndexWithinVariant === 0 ? `Serial numbers ${variantString}: ` : `${variantString}: `;
}

export function buildDeliveryNoteSerialTextLines(serialEntries, options = {}) {
  if (!Array.isArray(serialEntries) || serialEntries.length === 0) return [];

  const maxSerialsPerLine = options.maxSerialsPerLine ?? DEFAULT_MAX_SERIALS_PER_LINE;
  const maxTextLineLength = options.maxTextLineLength ?? DEFAULT_MAX_TEXT_LINE_LENGTH;

  const normalizedSerials = serialEntries.map(normalizeDeliveryNoteSerialEntry).filter(Boolean);
  if (normalizedSerials.length === 0) return [];

  const serialsByVariant = new Map();

  normalizedSerials.forEach((serialEntry) => {
    const variantKey = serialEntry.variantString || '';
    if (!serialsByVariant.has(variantKey)) {
      serialsByVariant.set(variantKey, []);
    }

    serialsByVariant.get(variantKey).push(serialEntry.serialNumber);
  });

  const textLines = [];

  serialsByVariant.forEach((serialNumbers, variantString) => {
    let currentSerialNumbers = [];
    let lineIndexWithinVariant = 0;

    serialNumbers.forEach((serialNumber) => {
      const linePrefix = getSerialLinePrefix(variantString || null, lineIndexWithinVariant);
      const nextSerialNumbers = [...currentSerialNumbers, serialNumber];
      const nextTextLine = `${linePrefix}${nextSerialNumbers.join('/')}`;

      if (currentSerialNumbers.length > 0 && (nextSerialNumbers.length > maxSerialsPerLine || nextTextLine.length > maxTextLineLength)) {
        textLines.push(`${linePrefix}${currentSerialNumbers.join('/')}`);
        currentSerialNumbers = [serialNumber];
        lineIndexWithinVariant += 1;
        return;
      }

      currentSerialNumbers = nextSerialNumbers;
    });

    if (currentSerialNumbers.length > 0) {
      const linePrefix = getSerialLinePrefix(variantString || null, lineIndexWithinVariant);
      textLines.push(`${linePrefix}${currentSerialNumbers.join('/')}`);
    }
  });

  return textLines;
}

export function buildDeliveryNoteSerialLines(serialEntries, lineInterface, options = {}) {
  return buildDeliveryNoteSerialTextLines(serialEntries, options).map((textLine) => ({
    ...lineInterface,
    Lijnnr: null,
    bonnr: 'new',
    aantal: null,
    VP: null,
    produktnr: 1,
    tekstlijn: textLine,
    aantalbesteld: null,
    aantalgeleverd: null,
    plaats: null,
    signedoff: false,
    opbon: false,
    garantie: false
  }));
}
